const injectMarketTool = loginInfo => {
  if (!loginInfo) return;
};

export default {
  injectMarketTool,
};
